// extracted by mini-css-extract-plugin
module.exports = {"event-form":"EventForm_event-form__3-Z4o","footer":"EventForm_footer__1oLuz","select":"EventForm_select__1iTua","input":"EventForm_input__1sJnl","switch":"EventForm_switch__1VlGy"};